/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppParametersResponse
 */
export interface AppParametersResponse {
    /**
     * 
     * @type {string}
     * @memberof AppParametersResponse
     */
    appName: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AppParametersResponse
     */
    appParameters: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AppParametersResponse
     */
    userId: string;
}

/**
 * Check if a given object implements the AppParametersResponse interface.
 */
export function instanceOfAppParametersResponse(value: object): value is AppParametersResponse {
    if (!('appName' in value) || value['appName'] === undefined) return false;
    if (!('appParameters' in value) || value['appParameters'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function AppParametersResponseFromJSON(json: any): AppParametersResponse {
    return AppParametersResponseFromJSONTyped(json, false);
}

export function AppParametersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppParametersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'appName': json['app_name'],
        'appParameters': json['app_parameters'],
        'userId': json['user_id'],
    };
}

export function AppParametersResponseToJSON(json: any): AppParametersResponse {
    return AppParametersResponseToJSONTyped(json, false);
}

export function AppParametersResponseToJSONTyped(value?: AppParametersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'app_name': value['appName'],
        'app_parameters': value['appParameters'],
        'user_id': value['userId'],
    };
}

